import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { api } from "@/lib/api";
import { FeedVideo } from "@/components/feed/FeedVideo";
import { FeedImages, FeedTextSlide, FeedCaption } from "@/components/feed/FeedMedia";
import { FeedActionRail, FeedCommentsSheet } from "@/components/feed/FeedActions";

/** Um ecrã do Feed: média em fundo; em baixo, legenda à esquerda e coluna reservada (64px) à direita para as ações. */
export function FeedSlide({ item, user, active, muted, onToggleMute, onRemoved, slideRef }) {
  const testid = `feed-item-${item.type}-${item.id}`;
  const base = item.type === "community" ? "community" : "profile";
  const [comments, setComments] = useState(false);
  const [count, setCount] = useState(item.comments_count || 0);
  const refreshCount = () => api.get(base === "community" ? `/community-posts/${item.id}` : `/profile/posts/${item.id}`).then((r) => setCount(r.data.comments_count)).catch(() => {});
  const hasVideo = !!item.video?.id;
  const hasImages = item.images?.length > 0;

  return (
    <section ref={slideRef} data-testid={testid} data-type={item.type} data-active={active} data-key={`${item.type}:${item.id}`}
             className="relative h-full w-full snap-start snap-always shrink-0 overflow-hidden bg-black">
      {hasVideo ? <FeedVideo video={item.video} active={active} muted={muted} testid={`${testid}-video`} />
        : hasImages ? <FeedImages images={item.images} testid={`${testid}-images`} />
        : <FeedTextSlide item={item} testid={`${testid}-textslide`} />}

      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/85 via-black/35 to-transparent" aria-hidden="true" />

      <div className="absolute inset-x-0 bottom-0 flex items-end gap-2 pl-4 pr-2 pb-3" data-testid={`${testid}-overlay`}>
        <div className="flex-1 min-w-0" data-testid={`${testid}-caption-col`}>
          <FeedCaption item={item} testid={`${testid}-caption`} />
        </div>
        <div className="w-14 shrink-0 flex flex-col items-center gap-4" data-testid={`${testid}-rail`}>
          <FeedActionRail item={item} user={user} base={base} onRemoved={onRemoved} onOpenComments={() => setComments(true)} commentsCount={count} />
          {hasVideo && (
            <button type="button" onClick={onToggleMute} aria-label={muted ? "Ativar som" : "Silenciar"} data-testid={`${testid}-mute`} data-muted={muted}
                    className="h-11 w-11 inline-flex items-center justify-center rounded-full bg-black/50 backdrop-blur text-white">
              {muted ? <VolumeX size={20} /> : <Volume2 size={20} />}
            </button>
          )}
        </div>
      </div>

      <FeedCommentsSheet item={item} user={user} base={base} open={comments} onOpenChange={setComments} onCount={refreshCount} />
    </section>
  );
}
